module.exports = __webpack_public_path__ + "img/Asset-202_2.25deb3c0.png";